import { useCallback, useContext, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { ProtocolContext } from "../contexts/ProtocolProvider";

const useNextAndPrevious = ({ principleId, sections }) => {
  const { protocolId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const sectionIdParam = searchParams.get("section");
  const questionId = searchParams.get("question");
  const [next, setNext] = useState();
  const [previous, setPrevious] = useState();
  const { protocol = {} } = useContext(ProtocolContext);
  const currentSections = sections
    ?.filter((section) => section?.questionsCount > 0)
    .filter((section) =>
      section?.principles?.find((_principle) => {
        if (!principleId) return true;
        return _principle.principleId === principleId;
      }),
    );

  const setSearchParamsWhenSectionOrQuestionNotSet = useCallback(() => {
    if (sectionIdParam && questionId) return;
    if (sectionIdParam && currentSections?.length && !questionId) {
      setSearchParams({
        section: sectionIdParam || currentSections[0]?.id,
        question:
          protocol?.questions?.filter(
            (question) => question?.section?.id === sectionIdParam,
          )?.[0]?.id || "",
      });
    } else if (!sectionIdParam && currentSections?.length) {
      setSearchParams({
        section: currentSections[0]?.id || "",
        question:
          protocol?.questions?.filter(
            (question) => question?.section?.id === currentSections[0]?.id,
          )?.[0]?.id || "",
      });
    }
  }, [currentSections, protocol, questionId, sectionIdParam, setSearchParams]);

  useEffect(() => {
    setSearchParamsWhenSectionOrQuestionNotSet();
  }, [setSearchParamsWhenSectionOrQuestionNotSet]);

  useEffect(() => {
    const activeSectionId = sectionIdParam || currentSections?.[0]?.id || "";
    const sectionIndex =
      currentSections?.findIndex(
        (section) => section?.id === activeSectionId,
      ) || 0;
    const sectionId = currentSections?.[sectionIndex]?.id || "";
    const filteredSectionsQuestions = protocol?.questions?.filter(
      (question) => question?.section?.id === sectionId,
    );
    const questionIndex =
      filteredSectionsQuestions?.findIndex(
        (question) => question?.id === questionId,
      ) || 0;

    let nextQuestion = filteredSectionsQuestions?.[questionIndex + 1] || {};
    let prevQuestion = filteredSectionsQuestions?.[questionIndex - 1] || {};

    let prevSectionId = sectionId;

    if (!Object.keys(prevQuestion).length) {
      let previousSection = currentSections[sectionIndex - 1];
      if (previousSection) {
        prevQuestion = protocol?.questions?.filter(
          (question) => question?.section?.id === previousSection?.id,
        );
        prevQuestion =
          prevQuestion?.length > 0
            ? prevQuestion[prevQuestion.length - 1]
            : null;
        prevSectionId = previousSection?.id || sectionId;
      }
    }

    let nextSectionId = sectionId;
    if (!Object.keys(nextQuestion).length) {
      let nextSection = currentSections[sectionIndex + 1];
      if (nextSection) {
        nextQuestion = protocol?.questions?.filter(
          (question) => question?.section?.id === nextSection?.id,
        );
        nextQuestion = nextQuestion?.length > 0 ? nextQuestion[0] : null;
        nextSectionId = nextSection?.id;
      }
    }
    setNext(
      () =>
        `/protocols/${protocolId}?section=${nextSectionId}&question=${nextQuestion?.id || ""}`,
    );
    setPrevious(
      () =>
        `/protocols/${protocolId}?section=${prevSectionId}&question=${prevQuestion?.id || ""}`,
    );
  }, [
    currentSections,
    principleId,
    protocol?.questions,
    protocolId,
    questionId,
    sectionIdParam,
    sections,
  ]);

  return { next, previous };
};

export default useNextAndPrevious;
